module.exports = __webpack_public_path__ + "img/white-cam-4.b7ec93d6.png";